import * as React from 'react';
import Selector, { ISelectorData } from './Selector';
import './FilterReport.scss';
import { Producer, SummaryProducer } from '../Models/Report';

export interface IFilterReportProps {
	producers: Producer[];
	onChangeProducer: (value: string | number) => void;
	onChangeBranch: (value: string | number) => void;
	selected?: SummaryProducer;
}

const FilterReport = (props: IFilterReportProps) => (<div className="FilterReport">
	{props.producers.length !== 1 && <Selector onChange={props.onChangeProducer} placeholder="Seleccionar Minera" data={props.producers.map(p => ({ label: p.name, value: p.id }) as ISelectorData)} />}
	<Selector onChange={props.onChangeBranch} placeholder="Seleccionar Faena" data={props.selected ? props.selected!.branchs.filter(b => b.total > 0).map(b => ({ label: b.name, value: b.id })) : []} />
</div>)

export default FilterReport;
